import { InvokeCallback, Sender } from "xstate";
import { buildAuthorizationsApiWithToken } from "@rentablo/api/apiv1";
import i18next from "i18next";
import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

const init2FA = async (userId: number) => {
  const authorizationsApi = await buildAuthorizationsApiWithToken();
  const { data } = await authorizationsApi.init2FA({ userId: userId! });
  return data;
};

const queryApi = async (
  callback: Sender<Settings2FAEvent>,
  userId?: number
) => {
  try {
    if (!userId) throw new Error("User ID is required");

    const data = await init2FA(userId);

    callback({
      type: "SECRET_FETCHED",
      qrCodeUrl: data.qrImage!,
    });
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    callback({
      type: "ERROR",
      message: i18next.t("settings.twoFA.messages.qrLoadError"),
    });
  }
};

export const fetchSecret =
  (
    _context: Settings2FAContext,
    _event: Settings2FAEvent
  ): InvokeCallback<Settings2FAEvent, Settings2FAEvent> =>
  (callback) => {
    queryApi(callback, _context.userId);
  };
